<div
  class="container"
  [ngStyle]="{ 'max-height': maxHeight }">
  <h3>{{ 'guided-tour.intro-headline' | translate }}</h3>
  <div class="fv-intro-text-block">
    <div class="overall-text">
      <p [innerHTML]="textContent"></p>
    </div>
  </div>
</div>
